import { useMemo } from 'react';
import { Alert, Typography, Slide, Stack } from '@mui/material';
import { useAppSelector } from '../../app/hooks';
import {
  processMaintenanceInfo,
  useMaintenanceInfo,
  getMaintenanceFeaturesLabels,
} from '@features/admin/adminAPI';
import { selectIsMaintenanceActive } from '@features/view/viewSlice';
import { selectIsGlobalAdmin } from '@features/auth/authSlice';

const GlobalAdminMaintenanceBanner = () => {
  const { data } = useMaintenanceInfo();

  const isGlobalAdmin = useAppSelector(selectIsGlobalAdmin);
  const isMaintenanceActive = useAppSelector(selectIsMaintenanceActive);

  const formattedMaintenanceInterval = useMemo(() => {
    if (data) {
      const info = processMaintenanceInfo(data);
      if (info) return info.formattedMaintenanceInterval;
    }
    return 'Unknown';
  }, [data]);

  const affectedFeatures = useMemo(() => {
    if (data?.features) return getMaintenanceFeaturesLabels(data.features);

    return 'LEO Cloud';
  }, [data]);

  const reason = useMemo(() => {
    if (data?.reason) return data.reason;
    return 'We are performing scheduled maintenance to improve our services and enhance your experience.';
  }, [data]);

  if (isMaintenanceActive && isGlobalAdmin)
    return (
      <Slide in={isMaintenanceActive && isGlobalAdmin} appear>
        <Alert
          variant="filled"
          severity="warning"
          slotProps={{
            message: {
              sx: {
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              },
            },
          }}
        >
          <Stack alignItems={'center'}>
            <Typography variant="h6">
              Scheduled Maintenance Is Active for {affectedFeatures}
            </Typography>
            <Stack direction={'row'} columnGap={1}>
              <Typography
                sx={{
                  display: 'flex',
                  gap: 0.5,
                }}
              >
                <strong>Date:</strong>
                {formattedMaintenanceInterval}
              </Typography>
            </Stack>
            <Typography>{reason}</Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              users cannot access {affectedFeatures} currently
            </Typography>
          </Stack>
        </Alert>
      </Slide>
    );
};

export default GlobalAdminMaintenanceBanner;
